import axios from 'axios'

export default {
  find: code => axios.get(`/api/barcodes/${code}`).then(({data}) => data),
  countAllActive: (params) => axios.get(`/api/barcodes/search/active`, {params: removeUndefined(params)}).then(({data}) => data)
}

function removeUndefined(obj) {
  Object.keys(obj).forEach((key) => {
    if ((obj[key] === undefined) || (obj[key] === "")) {
      delete obj[key]
    }
  });
  return obj
}
